import numberFormat from "../NumberFormat";

function StatsDisplay({stats, round}) {
    var rows = [];
    for (var stat in stats) {
        rows.push(<tr><td>{stat}</td><td>{numberFormat(stats[stat])}</td></tr>)
    }
    return <div className='game'>
        Round: {round}
        <table>
            <tbody>
            {rows}
            </tbody>
        </table>
    </div>
}

export default StatsDisplay;